<template>
  <template v-if="home">
    <section id="hero" class="d-flex flex-column justify-content-center">

      <ImageSlider v-if="home?.site_inicio_album"
        :slides="home?.site_inicio_album.images" 
        :interval="5000" 
        :autoPlay="true"
        :showDots="false" 
      />
      
      <div class="home-bottom">
        <div class="container text-center">
          <div class="move bounce">
            <a href="#about" class="bi bi-chevron-down">
            </a>
          </div>
        </div>
      </div>
    </section><!-- End Hero -->

    <main id="main">
      <SectionComponent v-if="home?.site_inicio?.inscripcion_mostrar" :id="'inscripcion'" :class="'inscripcion'">
        <div class="d-flex justify-content-center">
          <router-link class="btn btn-lg fw-bold text-white px-5 py-3 shadow-lg d-inline-block"
            style="background: #ff4500; border-radius: 0;"
            role="button"
            :to="{ name: 'inscripciones' }">
            {{ home?.site_inicio?.inscripcion_titulo }}
          </router-link>
        </div>
      </SectionComponent>
      <SectionComponent v-if="home?.site_inicio?.inscripcion_ecoferia_mostrar" :id="'inscripcionecoferia'" :class="'inscripcion'">
        <div class="d-flex justify-content-center">
          <router-link class="btn btn-lg fw-bold text-white px-5 py-3 shadow-lg d-inline-block"
            style="background: rgb(25, 81, 0); border-radius: 0;"
            role="button"
            :to="{ name: 'ecoferia' }">
            {{ home?.site_inicio?.inscripcion_ecoferia_titulo }}
          </router-link>
        </div>
      </SectionComponent> 
      <SectionComponent v-if="home?.site_inicio?.boton_ext_mostrar" :id="'botonext'" :class="'inscripcion'">
        <div class="d-flex justify-content-center">
          <a :href="home.site_inicio.boton_ext_url" class="btn btn-lg fw-bold text-white px-5 py-3 shadow-lg d-inline-block rounded-0"
            :style="`background: ${home.site_inicio.boton_ext_color};`"
            role="button" 
            target="_blank">
            {{ home?.site_inicio?.boton_ext }}
          </a>
        </div>
      </SectionComponent> 
      
      <SectionComponent v-if="home?.site_inicio" :id="'about'" :class="'about'" :title="home.site_inicio.accesos_titulo" :text="home.site_inicio.accesos_texto">
        <div v-if="home.site_inicio_accesos && home.site_inicio_accesos.length" class="niveles-educativos container my-5">
          <div class="row row-cols-1 g-4 mb-5 row-cols-sm-1 row-cols-md-2 row-cols-lg-3 niveles-educativos">

            <!-- Nivel Inicial -->
            <div v-for="item_acceso of home.site_inicio_accesos" v-bind:key="item_acceso.id_acceso" class="col">
              <div class="card h-100">
                <div class="card-header bg-inicial" :style="{  backgroundImage: `url(/images/accesos/${item_acceso.id_acceso}/${item_acceso.imagen})`, backgroundColor: item_acceso.color, color: getContrastColor(item_acceso.color) }">{{ item_acceso.titulo }}</div>
                <div class="card-body" v-html="item_acceso.texto"></div>
                <div class="card-footer bg-white border-0 d-grid gap-2">
                  <a :href="isURL(item_acceso.link) ? item_acceso.link : item_acceso.link" :target="isURL(item_acceso.link) ? '_BLANK' : ''" class="btn" :style="{ backgroundColor: item_acceso.color, color: getContrastColor(item_acceso.color) }">Más información</a>
                  <a href="contacto" class="btn" :style="{ backgroundColor: item_acceso.color, color: getContrastColor(item_acceso.color) }"><i class="bi bi-envelope"></i> Contacto</a>
                </div>
              </div>
            </div> 
          </div> 
        </div>
      </SectionComponent>
      <!-- ======= About Us Section ======= 
      <SectionComponent v-if="home?.site_inicio" :id="'about'" :class="'about'" :title="home.site_inicio.institucional_titulo" :subtitle="home.site_inicio.institucional_texto" :text="home.site_inicio.institucional_desarrollo">
        <div class="d-flex justify-content-center">
          <ButtonComponent :href="'/institucional/'" :caption="'Leer Más ...'" :hollow="true"/>
        </div>
      </SectionComponent>
       End About Us Section -->



      <section v-if="home?.site_novedades || home?.site_novedades_destacadas" id="novedades-events" class="novedades-events">
        <div class="container">
          <h2 class="text-center">{{ home.site_inicio.novedades_titulo }}</h2>
          <p v-html="home.site_inicio.novedades_texto" />
          <NoticiasComponent v-if="home.site_novedades_destacadas && home.site_novedades_destacadas.length" :noticias="home.site_novedades_destacadas"/>
          <NoticiasComponent v-if="home.site_novedades && home.site_novedades.length" :noticias="home.site_novedades"/>
          <div class="d-flex justify-content-center">
            <ButtonComponent :href="'/novedades/'" :caption="'Ver más...'" :hollow="true"/>
          </div>
        </div>
      </section>


      <PagoSiroComponent />
  
      <!-- ======= Contact Section ======= -->
      <SectionComponent v-if="home?.site_inicio" :id="'contact'" :class="'contact mb-5'" :title="home.site_inicio.contacto_titulo" :text="home.site_inicio.contacto_texto">
        <div class="container">
          <div class="row mt-5">
            <!-- div :class="home?.site_inicio.contacto_url ? 'col-lg-6' : 'col-lg-4'" -->
              <DireccionesComponent />
            <!-- /div -->
            <!-- div :class="home?.site_inicio.contacto_url ? 'col-lg-6 text-center' : 'col-lg-8 mt-5 mt-lg-0'">
              <ButtonComponent v-if="home?.site_inicio.contacto_url" class="mt-5" :href="home?.site_inicio.contacto_url" :caption="'Enviar Consulta'" target="blank" />
              <FormConsultaComponent v-else />
            </div -->
          </div>
        </div>
      </SectionComponent>
      <GoogleMapsComponent v-if="home?.site_inicio && home.site_inicio.map" :src="home.site_inicio.map" />
      
    </main><!-- End #main -->	
  </template>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { getContrastColor } from '../utils/common.utils.js'
import MesComponent from '../components/general/MesComponent.vue'
import TitleComponent from '../components/general/TitleComponent.vue'
import SectionComponent from '../components/general/SectionComponent.vue'
import ButtonComponent from '../components/general/ButtonComponent.vue'
import NoticiasComponent from '../components/noticias/NoticiasComponent.vue'
import NoticiasDestacadasComponent from '../components/noticias/NoticiasDestacadasComponent.vue'
import EventosComponent from '../components/eventos/EventosComponent.vue'
import GoogleMapsComponent from '../components/general/GoogleMapsComponent.vue'
import DireccionesComponent from '../components/general/DireccionesComponent.vue'
import FormConsultaComponent from '../components/general/FormConsultaComponent.vue'
import AlbumComponent from '../components/general/AlbumComponent.vue'
import ImageSlider from '../components/general/ImageSlider.vue'
import PagoSiroComponent from '../components/general/PagoSiroComponent.vue'

export default {
  name: 'HomeView',
  components: {
    MesComponent,
    TitleComponent,
    SectionComponent,
    ButtonComponent,
    NoticiasComponent,
    NoticiasDestacadasComponent,
    EventosComponent,
    GoogleMapsComponent,
    DireccionesComponent,
    FormConsultaComponent,
    AlbumComponent,
    ImageSlider,
    PagoSiroComponent
  },
  setup(){
    //const home = computed(() => store.state.home)
    // Define a reactive variable to store your data
    const home = ref(null)
    const store = useStore()
    
    const videoLoaded = () => {
      //store.commit('setLoading', false)
    }
    const isURL = (str) => {
      return (str.indexOf("http://") == 0 || str.indexOf("https://") == 0)
    }
    const fetchHome = async () => {
      store.commit('setLoading', true)
      try {
        const response = await fetch('home', { 'auth': true })
        const responseData = await response.json()
        // Assign the fetched data to the reactive variable
        home.value = responseData
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        store.commit('setLoading', false)
      }
    }

    // Call the fetchData function when the component is mounted
    onMounted(() => {
      //store.commit('setLoading', true)
      fetchHome()
    })

    return {home, isURL, videoLoaded, getContrastColor}
  }

}
</script>

<style scoped>

.background-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Optional: to darken the video */
}
.container-boxes {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  z-index: 1;
  padding-bottom: 55px; /* Adjust as needed */
}
.container-boxes a {
  overflow: hidden;
}
.box {
  height: 188px;
  color: white;
  border-radius: 15px;
  background-color: #05264f;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.box-text {
  text-align: center;
  text-transform: uppercase;
  color: white;
  padding-top: 10px;
}
.small-text {
  text-align: center;
  font-size: 12px;
  color: gray;
  text-transform: uppercase;
}

 
    .educational-levels {
      margin-top: 50px;
    }

    .educational-levels .card {
      border: none;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      transition: transform 0.3s ease;
    }

    .educational-levels .card:hover {
      transform: scale(1.02);
    }

    .novedades-events {
      
      background-color: #04438730;
      padding: 15px 0;
      color: #0F4B8D;

    }

    .novedades-events h2 {
      font-family: "Poppins", Sans-serif;
      font-size: 29px;
      text-align: center;
      padding-top: 10px;
      padding-bottom: 10px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .novedades-events p {
      font-family: "Poppins", Sans-serif;
      font-size: 18px;
      margin-bottom: 30px;
      text-align: justify;
    }

    .payment-instructions {
      margin-top: 50px;
    }

    .payment-instructions img {
      max-width: 100%;
      height: auto;
    }

    .niveles-educativos .card {
      border: 0;
    }

    .niveles-educativos .card-header {
      height: 150px;
      color: white;
      font-size: 1.75rem;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      text-shadow: 1px 1px 2px rgba(0,0,0,0.6);
      border-radius: .9rem;
      background-blend-mode: soft-light; /* or multiply, screen, etc. */
      background-size: cover;
    }

    .niveles-educativos .btn {
      transition: background-color 0.3s ease;
      transition: transform 0.3s ease;
    }


    /* Hover Effects for Buttons */
    .niveles-educativos .btn:hover {
      transform: scale(1.05);
      filter: brightness(1.5); /* 20% brighter */
    }

    /* Hover Effects for Cards 
    .niveles-educativos .card {
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }*/
/*
    .niveles-educativos .card:hover {
      transform: scale(1.03);
      box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.15);
    }*/



@media (max-width: 1600px) {
  .box {
    width: 13vw;
    height: 195px;
  }
  .circle {
    width: 93px;
    height: 93px;
    font-size: 2.5em;
  }
}

@media (max-width: 1024px) {
  .box {
    width: 20vw;
    height: 188px;
  }
  .circle {
    width: 83px;
    height: 83px;
    font-size: 2.5em;
  }
  #hero {
    height: 52vw;
  }
  #hero video{
    height: 52vw;
  }
}

@media (max-width: 768px) {
  .box {
    width: 22vw;
    height: 168px;
    margin: 18px 6px 36px 6px;
    font-size: 0.8em;    
  }
  
  .circle {
    width: 80px;
    height: 80px;
    font-size: 2.2em;
  }  
}
@media (max-width: 640px) {
  .box {
    width: 27vw;
    height: 150px;
  }
  
  .circle {
    width: 60px;
    height: 60px;
    font-size: 2.2em;
  }
}
@media (max-width: 480px) {
  .box {
    width: 27vw;
    height: 30vw;
    margin: 18px 6px 36px 6px;
    font-size: 0.8em;    
  }
  
  .circle {
    width: 11vw;
    height: 11vw;
    font-size: 2.2em;
  }

  #hero {
    height: 72vw;
  }
  #hero video{
    height: 72vw;
  }
}


</style>